import { CMSLink } from '~/shared/components';
import styles from './avatar-icon.module.css';
import { useClub } from '~/features/club';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';
import User from '$icons/solidAsh/user.svg';
import clsx from 'clsx';

export const AvatarIcon = () => {
    const { isAuthenticated, toggleSignInActive } = useClub();
    const { data: frame } = useFrame();
    const { translate } = useTranslation();
    const clubUrl = frame?.staticLinks?.clubPage?.url || '';
    const label = isAuthenticated
        ? translate('accessibility.goToAccount')
        : translate('accessibility.signInSignUp');

    if (!clubUrl) return null;

    return (
        <div className={styles.root}>
            {isAuthenticated ? (
                <CMSLink href={clubUrl} className={styles.link} aria-label={label}>
                    <User />
                </CMSLink>
            ) : (
                <button
                    className={clsx('cleanButton', styles.button)}
                    onClick={() => toggleSignInActive(true)}
                    aria-label={label}
                >
                    <User />
                </button>
            )}
            <span className={styles.tooltipText}>{label}</span>
        </div>
    );
};
